import React from 'react';
import { withRouter } from 'react-router-dom';
import BaseComponent from '../../../../baseClasses/BaseComponent';
import FileCard from './FileCard';
import csPhotoDefault from '../../../../assets/images/photo-jpg-placeholder.svg';
import MiscConstants from '../../../../constants/MiscConstants';
import './TaskCompletionStepPhotoGrid.scss';

// TODO: this component is duplicated - collapse into 1

/**
 * This component is used in the tasks container for web&mobile 
 * completion step uploads when at least one photo already exists under the step
 */
export class TaskCompletionStepPhotoGrid extends BaseComponent {
  constructor(props) {
    super(props);
    this.state = { 
      commentText: '',
      attachments: [],
    };
  }

  componentDidMount() {
    this.sortAttachments(this.props.attachments);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.uploadImageId != this.props.uploadImageId
        || this.attachmentsDiffer(this.props.attachments)) {
      this.sortAttachments(this.props.attachments);
    }
  }

  attachmentsDiffer(attachments) {
    if (attachments.length != this.state.attachments.length) {
      return true;
    }
    return !this.state.attachments.every(state_attachment => {
      const attachment = attachments.find(attachment => {
        return attachment.id == state_attachment.id;
      });
      return attachment && attachment._dirty == state_attachment._dirty && attachment.name == state_attachment.name;
    });
  }

  sortAttachments(attachments) {
    let newAttachments = [];
    if (attachments) {
      newAttachments = attachments.map(a => {
        return Object.assign({}, a);
      });
    }
    this.setState({
      attachments: newAttachments,
    });
  }

  handlePhotoSelection(attachment) {
    const { completionStep, task, userStepPermissions } = this.props;

    if (this.props.handlePhotoSelection) {
      this.props.handlePhotoSelection(attachment);
    }
    else {
      this.props.history.push({
        pathname: `/mobile/projects-tasks/task/${task.id}/completion_step/${completionStep.id}/photo-display/${attachment.id}`,
        state: {
          userStepPermissions: userStepPermissions,
        },
      });
    }
  }

  createPhotoList() {
    const { completionStep, task } = this.props;
    let attachDisplay = [];
      
    const filteredAttachments = this.state.attachments ? this.state.attachments.filter(attachment => {
      return !this.props.uploadImageId || this.props.uploadImageId != attachment.id;
    }) : [];

    attachDisplay = filteredAttachments.filter(attachment => attachment.upload || attachment.file_upload).map(attachment => {
      return (
        <FileCard 
          key={'photo-card-' + (attachment.id ? attachment.id : Math.ceil(Math.random() * 20000))} 
          attachment={attachment} 
          handlePhotoSelection={this.handlePhotoSelection}
          medium={this.props.medium} 
          noBorder={this.props.maxPhotos}
          taskId={task ? task.id : null}
          completionStepId={completionStep ? completionStep.id : null} 
          userStepPermissions={this.props.userStepPermissions}
          completionStepStatus={this.props.completionStepStatus}
          extensionType={completionStep ? completionStep.requested_file_type : null}
          handleFileSelected={this.props.handleFileSelected}
        />
      );
    });
    if (this.props.uploadInProgress) {
      //loading image for photo
      attachDisplay.push(
        <FileCard 
          key={'upload-image'} 
          uploadInProgress={true} 
          medium={this.props.medium} 
          noBorder={this.props.maxPhotos} 
          userStepPermissions={this.props.userStepPermissions} 
          completionStepStatus={this.props.completionStepStatus}
          extensionType={completionStep ? completionStep.requested_file_type : null}
        />
      );
    }
    return attachDisplay;
  }

  handleSetAttachmentToDefaultImage(newAttachment) {
    this.state.attachments.forEach(attachment => {
      if (attachment.id == newAttachment.id) {
        attachment.upload = csPhotoDefault;
      }
    });
  }

  render() {
    const { completionStep } = this.props;
    if (!completionStep && !this.state.attachments) {
      return null;
    }

    let display;
    
    const displayPhotoList = this.createPhotoList();
    const fileType = completionStep && completionStep.completion_type == 'file_upload' ? 'files' : 'photos';
    let height = 'auto';

    display = <div className={'task-completion-step-photo-grid ' + (this.props.withAcceptReject ? 'accept-reject' : '') + (this.props.maxPhotos ? ' transparent' : '')}>
        <div className={'photo-list ' + (this.props.withAcceptReject ? 'accept-reject' : '') + (this.props.maxPhotos ? ' transparent' : '')}>
          <div className="photos" style={{ height: height }}>
            {displayPhotoList}
          </div>
        {this.state.attachments.length == MiscConstants.MAX_NUMBER_OF_PHOTOS && <div className="no-more-allowed">
          Maximum number of {fileType} reached.
            </div>}
        </div>
      </div>;

    return (
      <div className={this.props.isInspection ? 'photo-grid_inspection' : ''}>
        {display}
      </div>
    );
  }
  
}

export default withRouter(TaskCompletionStepPhotoGrid);



// WEBPACK FOOTER //
// ./src/components/TaskCompletionStepsMobile/PhotoUpload/TaskCompletionStepPhotoGrid/index.js